import { combineReducers } from "redux";

import { applicationReducer } from './applicationReducer';
import { usersReducer } from './usersReducer'
import { hubReducer } from './hubReducer';
import { collectionsReducer } from './collectionsReducer';
import { assetsReducer } from './assetsReducer';
import { integrationsReducer } from './integrationsReducer';
import { linksReducer } from './linksReducer';
import { seekReducer } from './seekReducer';
import { loginReducer } from './loginReducer';
import { conversationsReducer } from "./conversationsReducer";
import {selectionReducer} from "./selectionReducer";
import { LOGOUT_USER } from "constants/actionTypes";
import { meetingReducer } from "./meetingReducer";

const appReducer = combineReducers({
  application: applicationReducer,
  users: usersReducer,
  streams: hubReducer,
  collections: collectionsReducer,
  assets: assetsReducer,
  integrations: integrationsReducer,
  links: linksReducer,
  seek: seekReducer,
  login: loginReducer,
  conversations: conversationsReducer,
  selection: selectionReducer,
  meeting: meetingReducer
})

const rootReducer = (state, action) => {
  if (action.type === LOGOUT_USER) {
    state = undefined
  }

  return appReducer(state, action)
}

export default rootReducer;